module.exports = __webpack_public_path__ + "front/img/text.274c8036.png";